import React from 'react';
import styles from "./Toggler.module.scss";
import { ToggleIcon } from '../../../../assets/icons/svgicons';

const Toggler = ({ className, onClick, show }) => {
    return (
        <button
            className={`${styles.toggler} ${true ? styles.tobe_read : ""} d-xl-none ${className || ""} ${show ? styles.active : ""}`}
            onClick={onClick}
        >
            <ToggleIcon />
        </button>
    )
}

export default Toggler
